import { OktaAuth } from '@okta/okta-auth-js'
import { LoginCallback, SecureRoute, Security, withOktaAuth } from '@okta/okta-react'
import ErrorBoundary from 'components/atoms/ErrorBoundary/ErrorBoundary'
import LocalTransportation from 'components/pages/Forms/Destinations/LocalTransportation'
import ErrorHandler from 'components/pages/Forms/ErrorHandler'
import Feedback from 'components/pages/Forms/Feedback/Feedback'
import HotelOnlineDisplay from 'components/pages/Forms/HotelOnlineDisplay/HotelOnlineDisplay'
import InventoryAlerts from 'components/pages/Forms/InventoryCloseouts/InventoryAlerts'
import GroupPolicy from 'components/pages/Forms/Policies/GroupPolicy'
import GuaranteeAndCancelPolicyWithSeasons from 'components/pages/Forms/Policies/GuaranteeAndCancelPolicyWithSeasons'
import AgeTiers from 'components/pages/Forms/Policies/AgeTiers'
import PetPolicy from 'components/pages/Forms/Policies/PetPolicy'
import Policies from 'components/pages/Forms/Policies/Policies'
import RackRateplan from 'components/pages/Forms/RackRates/RackRateplan'
import OtaRatePrograms from 'components/pages/Forms/Rateplans/OtaRatePrograms'
import OtherRateplans from 'components/pages/Forms/Rateplans/OtherRateplans'
import RateplanBlackouts from 'components/pages/Forms/Rateplans/RateplanBlackouts'
import SubmitForReview from 'components/pages/Forms/SubmitForReview/SubmitForReview'
import LaunchOnboardingApplication from 'components/pages/LaunchOnboardingApplication'
import UpdateOnboardingApplication from 'components/pages/UpdateOnboardingApplication'
import URLConst from 'constants/URLConst'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { clearSession } from 'utilities/SessionHelper'
import Footer from './components/organisms/Footer/Footer'
import Header from './components/organisms/Header/Header'
import Account from './components/pages/Account'
import AdminHotelList from './components/pages/AdminHotelList'
import Airports from './components/pages/Forms/Destinations/Airports'
import Attractions from './components/pages/Forms/Destinations/Attractions'
import Businesses from './components/pages/Forms/Destinations/Businesses'
import Destinations from './components/pages/Forms/Destinations/Destinations'
import LongDistanceTransportation from './components/pages/Forms/Destinations/LongDistanceTransportation'
import Lounges from './components/pages/Forms/Destinations/Lounges'
import Restaurants from './components/pages/Forms/Destinations/Restaurants'
import Spa from './components/pages/Forms/Destinations/Spa'
import ExtraCharges from './components/pages/Forms/ExtraCharges/ExtraCharges'
import HotelAmenities from './components/pages/Forms/HotelAmenities/HotelAmenities'
import EmergencyContacts from './components/pages/Forms/HotelContacts/EmergencyContacts'
import HotelContacts from './components/pages/Forms/HotelContacts/HotelContacts'
import OnboardingContact from './components/pages/Forms/HotelContacts/OnboardingContact'
import OpeningServiceDirectorContact from './components/pages/Forms/HotelContacts/OpeningServiceDirectorContact'
import OnlineTravelAgentContact from './components/pages/Forms/HotelContacts/OnlineTravelAgentContact'
import HotelInfo from './components/pages/Forms/HotelInfo/HotelInfo'
import MeetingRoom from './components/pages/Forms/MeetingRooms/MeetingRoom'
import MeetingRooms from './components/pages/Forms/MeetingRooms/MeetingRooms'
import BoxInventory from './components/pages/Forms/Rateplans/BoxInventory'
import SrpInventory from './components/pages/Forms/Rateplans/SRPInventory'
import Rateplans from './components/pages/Forms/Rateplans/Rateplans'
import RoomType from './components/pages/Forms/RoomTypes/RoomType'
import RoomTypes from './components/pages/Forms/RoomTypes/RoomTypes'
import TaxesAndCharges from './components/pages/Forms/TaxesAndCharges/TaxesAndCharges'
import NotFound from './components/pages/NotFound'
import SearchHotel from './components/pages/SearchHotel'
import TermsAndConditions from './components/pages/TermsAndConditions'
import RouteConst from './constants/RouteConst'
import SearchHotelHistory from './components/pages/SearchHotelHistory'
import SearchHotelHistoryDetails from './components/pages/SearchHotelHistoryDetails'
import InitialOPDContact from 'components/pages/InitialOPDContact'
import UserError from 'components/pages/UserError'
import Configuration  from './components/pages/Forms/Configurations/Configuration'
import RatePlanConfiguration  from './components/pages/Forms/Configurations/RatePlanConfiguration'
import RatesConfiguration  from './components/pages/Forms/Configurations/RatesConfiguration'
import MasterBoxConfiguration  from './components/pages/Forms/Configurations/MasterBoxConfiguration'
import RoomTypeBuckets from "./components/pages/Forms/RoomTypeBuckets/RoomTypeBuckets";
import RoomTypeBucket from "./components/pages/Forms/RoomTypeBuckets/RoomTypeBucket";
import HotelContent from './components/pages/Forms/HotelContent/HotelContent';
import HotelContentWedding from './components/pages/Forms/HotelContent/HotelContentWedding';

import './App.scss'


/**
 * The application component.
 * Contains the common app format wrapped by the OKTA securiy component.
 * Header - Router with all page routes - Footer.
 * Includes the auth error modal which redirects to OKTA user home on authentication errors.
 */
class App extends Component {
    state = {
        user: {},
        showAccessError: false
    }

    componentDidMount = () => {
        window.onunhandledrejection = this.handleUserNotAssignedToAppError
    }

    handleUserNotAssignedToAppError = (event) => {

        if (event.reason.errorCode === 'access_denied' 
            && event.reason.errorSummary.includes('User is not assigned to the client application')) {
            this.setState({ showAccessError: true }) 
        }
    }

    // OKTA client ids
    CLIENT_ID = {
        'https://choicepropel-core-ota-dev.distdev.cloud.chotel.com': '0oazom8kq5jxoByKr0h7',
        'https://choicepropel-dev.distdev.cloud.chotel.com:9000': '0oazom8kq5jxoByKr0h7',
        'https://propel-core-ec-sit.distdev.cloud.chotel.com': '0oawqqdwlaIjjhtzc0h7',
        'https://choicepropel-core-ec-sit.distdev.cloud.chotel.com': '0oazompvmieVlR2U90h7',
        'https://choicepropel-core-ec-rit.distpreprod.cloud.chotel.com': '0oazomljjfa7l0OpC0h7',
        'https://choicepropel-core-ec-prod.distprod.cloud.choicehotels.com': '0oa3j9cenmnw5w7qA4x7',
        'https://choicepropel-core-ec-prod.distprod.cloud.chotel.com': '0oa3j9cenmnw5w7qA4x7',
        'https://test.chotel.com:9000': '0oatbquceeqJgU4mM0h7'
    }

    // OKTA config
    config = {
        issuer: URLConst.OKTA_SERVICE + URLConst.PATH_OKTA_ISSUER,
        clientId: this.CLIENT_ID[window.location.origin],
        pkce: true,
        redirectUri: window.location.origin + '/implicit/callback',
        storageManager: {
            token: {
                storageTypes: [
                    'sessionStorage'
                ],
                useMultipleCookies: true // puts each token in its own cookie
            },
            cache: {
                storageTypes: [
                    'sessionStorage'
                ]
            },
            transaction: {
                storageTypes: [
                    'sessionStorage'
                ]
            }
        },
        tokenManager: {
            storage: 'sessionStorage'
        }
    }
    oktaAuth = new OktaAuth(this.config)

    restoreOriginalUri = async (_oktaAuth, originalUri) => {
        window.location.replace(originalUri || '/')
    }

    render() {

        return <div>
            <BrowserRouter>
                <Security oktaAuth={this.oktaAuth} restoreOriginalUri={this.restoreOriginalUri}>
                    <Header />
                    <div className='background'>
                        <div className='content'>
                        {
                            this.state.showAccessError &&
                            <div id='access-error' className='access-error'>
                                This system is used for onboarding new properties. If you are trying to onboard a new property, but the property 
                                does not appear in this section, please contact your Onboarding Project Director or Choice assigned Opening associate. 
                                If you are not currently onboarding a new Choice property, this system is not available.
                            </div>
                        }

                            <ErrorBoundary>
                                <Switch>
                                    <Route path={RouteConst.ROUTE_OKTA_CALLBACK} component={LoginCallback} />

                                    <SecureRoute path={RouteConst.ROUTE_HOME_PAGE} render={() => <SearchHotel />} exact />

                                    <SecureRoute path={RouteConst.ROUTE_LAUNCH_ONBOARDING_APPLICATION_PAGE} component={LaunchOnboardingApplication} exact />
                                    <SecureRoute path={RouteConst.ROUTE_ADMIN_PAGE} component={AdminHotelList} exact />
                                    <SecureRoute path={RouteConst.ROUTE_ACCOUNT_PAGE} component={Account} exact />
                                    <SecureRoute path={RouteConst.ROUTE_UPDATE_ONBOARDING_PAGE} component={UpdateOnboardingApplication} exact />
                                    <SecureRoute path={RouteConst.ROUTE_TERMS_AND_CONDITIONS_PAGE} component={TermsAndConditions} exact />

                                    <SecureRoute path={RouteConst.ROUTE_HOTEL_INFO_PAGE} component={HotelInfo} exact />

                                    <SecureRoute path={RouteConst.ROUTE_HOTEL_CONTACTS_PAGE} component={HotelContacts} exact />
                                    <SecureRoute path={RouteConst.ROUTE_EMERGENCY_CONTACTS_PAGE} component={EmergencyContacts} exact />
                                    <SecureRoute path={RouteConst.ROUTE_ONBOARDING_CONTACT} component={OnboardingContact} exact />
                                    <SecureRoute path={RouteConst.ROUTE_OSD_CONTACT} component={OpeningServiceDirectorContact} exact />
                                    <SecureRoute path={RouteConst.ROUTE_ONLINE_TRAVEL_AGENT_CONTACT} component={OnlineTravelAgentContact} exact />
                                    <SecureRoute path={RouteConst.ROUTE_HOTEL_ONLINE_DISPLAY_PAGE} component={HotelOnlineDisplay} exact />

                                    <SecureRoute path={RouteConst.ROUTE_HOTEL_CONTENT_PAGE} component={HotelContent} exact />
                                    <SecureRoute path={RouteConst.ROUTE_HOTEL_CONTENT_WEDDING_PAGE} component={HotelContentWedding} exact />

                                    <SecureRoute path={RouteConst.ROUTE_POLICIES_PAGE} component={Policies} exact />
                                    <SecureRoute path={RouteConst.ROUTE_PET_POLICY_PAGE} component={PetPolicy} exact />
                                    <SecureRoute path={RouteConst.ROUTE_GUARANTEE_CANCEL_POLICY_PAGE} component={GuaranteeAndCancelPolicyWithSeasons} exact />
                                    <SecureRoute path={RouteConst.ROUTE_AGE_TIERS_PAGE} component={AgeTiers} exact />
                                    <SecureRoute path={RouteConst.ROUTE_GROUP_POLICY_PAGE} component={GroupPolicy} exact />

                                    <SecureRoute path={RouteConst.ROUTE_HOTEL_TAXES_PAGE} component={TaxesAndCharges} exact />
                                    <SecureRoute path={RouteConst.ROUTE_EXTRA_CHARGES_PAGE} component={ExtraCharges} exact />
                                    <SecureRoute path={RouteConst.ROUTE_HOTEL_AMENITIES_PAGE} component={HotelAmenities} exact />

                                    <SecureRoute path={RouteConst.ROUTE_DESTINATIONS_PAGE} component={Destinations} exact />
                                    <SecureRoute path={RouteConst.ROUTE_AIRPORTS_PAGE} component={Airports} exact />
                                    <SecureRoute path={RouteConst.ROUTE_RESTAURANTS_PAGE} component={Restaurants} exact />
                                    <SecureRoute path={RouteConst.ROUTE_LOUNGES_PAGE} component={Lounges} exact />
                                    <SecureRoute path={RouteConst.ROUTE_ATTRACTIONS_PAGE} component={Attractions} exact />
                                    <SecureRoute path={RouteConst.ROUTE_BUSINESSES_PAGE} component={Businesses} exact />
                                    <SecureRoute path={RouteConst.ROUTE_LONG_DISTANCE_TRANSPORTATION_PAGE} component={LongDistanceTransportation} exact />
                                    <SecureRoute path={RouteConst.ROUTE_LOCAL_TRANSPORTATION_PAGE} component={LocalTransportation} exact />
                                    <SecureRoute path={RouteConst.ROUTE_SPA_PAGE} component={Spa} exact />

                                    <SecureRoute path={RouteConst.ROUTE_ROOM_TYPES_PAGE} component={RoomTypes} exact />
                                    <SecureRoute path={RouteConst.ROUTE_ROOM_TYPE_PAGE} component={RoomType} exact />
                                    <SecureRoute path={RouteConst.ROUTE_MEETING_ROOM_PAGE} component={MeetingRoom} exact />
                                    <SecureRoute path={RouteConst.ROUTE_MEETING_ROOMS_PAGE} component={MeetingRooms} exact />
                                    <SecureRoute path={RouteConst.ROUTE_INVENTORY_CLOSEOUTS_PAGE} component={InventoryAlerts} exact />

                                    <SecureRoute path={RouteConst.ROUTE_RACK_RATES_PAGE} component={RackRateplan} exact />
                                    <SecureRoute path={RouteConst.ROUTE_RATEPLANS_PAGE} component={Rateplans} exact />
                                    <SecureRoute path={RouteConst.ROUTE_BOX_INVENTORY_PAGE} component={BoxInventory} exact />
                                    <SecureRoute path={RouteConst.ROUTE_SRP_INVENTORY_PAGE} component={SrpInventory} exact />
                                    <SecureRoute path={RouteConst.ROUTE_OTA_RATE_PROGRAMS_PAGE} component={OtaRatePrograms} exact />
                                    <SecureRoute path={RouteConst.ROUTE_OTHER_RATEPLANS_PAGE} component={OtherRateplans} exact />
                                    <SecureRoute path={RouteConst.ROUTE_RATEPLAN_BLACKOUTS_PAGE} component={RateplanBlackouts} exact />

                                    <SecureRoute path={RouteConst.ROUTE_FEEDBACK_PAGE} component={Feedback} exact />
                                    <SecureRoute path={RouteConst.ROUTE_SUBMIT_FOR_REVIEW_PAGE} component={SubmitForReview} exact />

                                    <SecureRoute path={RouteConst.ROUTE_HISTORY_SEARCH_PAGE} component={SearchHotelHistory} exact />
                                    <SecureRoute path={RouteConst.ROUTE_HISTORY_DETAILS_PAGE} component={SearchHotelHistoryDetails} exact />

                                    <SecureRoute path={RouteConst.ROUTE_ONBOARDING_CONTACT_INITIAL} component={InitialOPDContact} exact />
                                    <SecureRoute path={RouteConst.ROUTE_USER_ERROR_PAGE} component={UserError} exact />

                                    <SecureRoute path={RouteConst.ROUTE_LAUNCH_CONFIGURE_PAGE} component={Configuration} exact />
                                    <SecureRoute path={RouteConst.ROUTE_RATE_PLAN_CONFIGURATION_PAGE} component={RatePlanConfiguration} exact />
                                    <SecureRoute path={RouteConst.ROUTE_RATES_CONFIGURATION_PAGE} component={RatesConfiguration} exact />
                                    <SecureRoute path={RouteConst.ROUTE_ROOM_TYPE_BUCKETS_PAGE} component={RoomTypeBuckets} exact />
                                    <SecureRoute path={RouteConst.ROUTE_ROOM_TYPE_BUCKET_PAGE} component={RoomTypeBucket} exact />

                                    <SecureRoute path={RouteConst.ROUTE_MASTER_BOX_CONFIGURATION_PAGE} component={MasterBoxConfiguration} exact />

                                    <Route path={RouteConst.ROUTE_LOGOUT_PAGE}
                                        component={() => {
                                            clearSession()
                                            window.location.href = URLConst.OKTA_SERVICE + URLConst.PATH_OKTA_LOGOUT_REDIRECT;
                                            return null;
                                        }}
                                        exact />
                                    <Route component={NotFound} />
                                </Switch>
                            </ErrorBoundary>
                        </div>
                    </div>
                    <Footer />
                    {/* 
                    Token refresh modal is not required. 
                    Okta automatically refeshes the token.
                    Any auth errors should be handled by ErrorHandler. 
                    */}
                    {/* 
                    <FormModal
                        id='refresh-token-modal'
                        hotelInfo={this.state.hotelInfo}
                        title={FormConst.MODAL_REFRESH_TOKEN_TITLE}
                        body={<h5>{FormConst.MODAL_REFRESH_TOKEN_TEXT}</h5>}
                        proceed={async () => {
                            await this.props.oktaAuth.authStateManager.updateAuthState()
                            this.setState({ showRefreshTokenModal: false })
                        }}
                        cancel={async () => {
                        }}
                        show={this.state.showRefreshTokenModal}
                    /> */}
                    <ErrorHandler isAuthError={this.props.isAuthError} showLockError={false} />
                </Security>
            </BrowserRouter>
        </div>
    }
}

// Map redux state to props
const mapStateToProps = state => {
    return {
        isLockError: state.reducer.isLockError,
        isAuthError: state.reducer.isAuthError
    }
}

export default connect(mapStateToProps)((withOktaAuth(App)))